let frame; 

export function setCanvasDimensions(canvas, w, h) {
    canvas.style.width = `${w}px`;
    canvas.width = w;
    canvas.style.height = `${h}px`;
    canvas.height = h;
}

export function startSpinner(canvas1, canvas2, options) {
    // console.log('startSpinner')
    let { radius, petals, tailLength, lineWidth, loopCount, persist, counterSpin, callback } = options; 
    let c = canvas1.getContext('2d');
    let c2 = canvas2.getContext('2d');
    let w = canvas1.width, h = canvas1.height; 
    //center coordinates, orient algebraically
    c.translate(w / 2, h / 2); c2.translate(w / 2, h / 2);
    c.scale(1.0, -1.0); c2.scale(1.0, -1.0);
    c.lineWidth = lineWidth || 5; c2.lineWidth = lineWidth || 5;
    //radius value
    let r = radius || Math.min(w / 2, h / 2) - 5; 
    //# of petals
    if (!petals || !(petals >= 3 && petals <= 9)) {
        //if petals unspecified or out of bounds, choose @ random between 3-9
        petals = 3 + Math.floor(Math.random() *7)
    }
    let count = 0; //iteration counter
    //Length of fading tail
    let fade; 
    switch (tailLength) {
    case 'short':
        fade = 50;
        break; 
    case 'long':
        fade = 150;
        break; 
    case 'medium':
    default:
        fade = 100;
        break; 
    }
    let head, tail, points, reversePoints;

    reset()
    frame = window.requestAnimationFrame(draw)
    function draw() {
        c.clearRect(-w / 2, -h / 2, w, h); c2.clearRect(-w / 2, -h / 2, w, h);
        //rotate canvases
        c.rotate(1 * Math.PI / 180); c2.rotate((counterSpin? -1 : 1) * Math.PI / 180); 
        // c.rotate(-1 * Math.PI / 180); c2.rotate((counterSpin? 1 : -1) * Math.PI / 180); 
        let finish = Math.min(head, 360);
        let delta = finish - tail;
        for (let i = 0; i < delta; i++) {
            let start = tail + i;
            let next = start + 1;
            c.beginPath();
            c.moveTo(points[start][0], points[start][1]);
            let grad = c.createLinearGradient(points[start][0], points[start][1], points[next][0], points[next][1]);
            grad.addColorStop(0, getSparkGradient(i / delta))
            grad.addColorStop(1, getSparkGradient((i + 1) / delta))
            c.strokeStyle = grad;
            c.lineTo(points[next][0], points[next][1])
            c.stroke();
            //secondary color, 
            c2.beginPath();
            c2.moveTo(reversePoints[start][0], reversePoints[start][1]);
            let grad2 = c2.createLinearGradient(reversePoints[start][0], reversePoints[start][1], reversePoints[next][0], reversePoints[next][1]);
            grad2.addColorStop(0, getLightGradient(i / delta))
            grad2.addColorStop(1, getLightGradient((i + 1) / delta))
            c2.strokeStyle = grad2;
            c2.lineTo(reversePoints[next][0], reversePoints[next][1])
            c2.stroke();
        }
        head++;
        tail = Math.max(0, head - fade);
        if (tail >= 360) {
            count++; 
            if (callback && count === loopCount) {
                callback();
                if (!persist) {
                    c.clearRect(-w / 2, -h / 2, w, h); //clear up final little bit left over
                    return; 
                }
            }
            else {
                reset();
            }
        }
        frame = window.requestAnimationFrame(draw); 
    }

    function reset() {
        points = plotter(petals, r);
        reversePoints = reversePlotter(petals, r);
        head = 1;
        tail = 0;
    }
}

export function stopSpinner() {
    // console.log('stopSpinner')
    window.cancelAnimationFrame(frame); 
}

// HELPER FUNCTIONS


function plotter(n, r) {
    const degToRads = Math.PI / 180;
    let points = new Array(361);
    points[0] = [0, 0];
    for (let i = 1; i <= 360; i++) {
        //i represents each degree, to rads theta = i * degToRads; 
        //polar equation is r = 50*sin(n*theta); polar to cartesian, x = 50sin(n*theta)cos(theta), y=50sin(n*theta)sin(theta)
        let theta = i * degToRads;
        points[i] = [r * Math.sin(n * theta) * Math.cos(theta), r * (Math.sin(n * theta) * Math.sin(theta))]
    }
    return points
}

function reversePlotter(n, r) {
    const degToRads = Math.PI / 180;
    let points = new Array(361);
    points[0] = [0, 0];
    for (let i = 1; i <= 360; i++) {
        //i represents each degree, to rads theta = i * degToRads; 
        //polar equation is r = 50*sin(n*theta); polar to cartesian, x = 50sin(n*theta)cos(theta), y=50sin(n*theta)sin(theta)
        let theta = (360 -i) * degToRads;
        points[i] = [r * Math.sin(n * theta) * Math.cos(theta), r * (Math.sin(n * theta) * Math.sin(theta))]
    }
    return points
}


function drawWhole(c, points) {
    c.beginPath();
    c.moveTo(points[0][0], points[0][1]);
    for (let p = 1; p < points.length; p++) {
        c.lineTo(points[p][0], points[p][1]);
    }
    c.closePath();
    c.stroke();
}

function getPrimaryGradient(alpha) {
    return `rgba(225, 180, 32, ${alpha})`
}
function getSparkGradient(alpha) {
    return `rgba(248, 214, 101, ${alpha})`
}
function getLightGradient(alpha) {
    return `rgba(250, 245, 240, ${alpha})`
}
